var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-unstyled text-left py-md-2"},_vm._l((_vm.pages),function(p){return _c('li',{key:p.rank,class:{ l1: p.level == 1, 'ml-3': p.level == 2, 'ml-5': p.level == 3 }},[(p.menu_item)?_c('router-link',{attrs:{"to":p.path == '' ? '/' : p.path}},[_vm._v(_vm._s(p.title))]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }